"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var React = require("react");
var form_element_hook_1 = require("./form-element-hook");
var CreateElement = form_element_hook_1.default;
/**
 *  This function takes in a useForm response and registers and renders form fields for collecting mailing info.
 * @param useHookResponse (call useForm() and store that in a variable, and then pass that in here)
 */
var MailingAddress = function (_a) {
    var useHookResponse = _a.useHookResponse;
    var register = useHookResponse.register, getValues = useHookResponse.getValues;
    var areMailingFieldsValid = function (field) {
        var values = getValues();
        var mailingAddress = values.mailingAddress;
        var mailingAddress2 = values.mailingAddress2;
        var mailingCity = values.mailingCity;
        var mailingState = values.mailingState;
        var mailingCountry = values.mailingCountry;
        var mailingZip = values.mailingZip;
        var fields = [mailingAddress, mailingAddress2, mailingCity, mailingState, mailingCountry, mailingZip];
        // 2 valid scenarios:
        //   1. No mailing fields are provided at all.
        //   2. One or more are provided, which requires others.
        // Map them to lengths.
        var filled = fields.map(function (field) { return field && field.length > 0; });
        // Are they all greater than 0?
        var allFilled = filled.reduce(function (acc, ele) { return acc && ele; });
        // Okay, then they're all filled out. Validation passes.
        if (allFilled) {
            return true;
        }
        // No? Now we check to make sure none of them are filled out.
        var empty = fields.concat([mailingAddress2]).map(function (field) { return !field || field.length == 0; });
        var allEmpty = empty.reduce(function (acc, ele) { return acc && ele; });
        // If they're all empty, thats fine.
        if (allEmpty) {
            return true;
        }
        // If we get here, they're not all empty, but they're not all filled.
        // Check to see if THIS field is filled. Dont error out this specific field if so.
        if (field && field.length > 0) {
            return true;
        }
        // Validation fails.
        return false;
    };
    return (React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
            React.createElement("div", null,
                React.createElement("h4", null, "Mailing Address"),
                React.createElement("span", { className: "u-fontSizeSm u-textNormal" }, "For off-line registration payments"))),
        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                            validate: function (value) { return areMailingFieldsValid(value) || "An address is required."; },
                        }), type: "text", field: "mailingAddress", label: "Address Line 1", placeholder: "Address Line 1" }))),
            React.createElement("br", null),
            React.createElement(teamsnap_ui_1.Grid, null,
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                        }), type: "text", field: "mailingAddress2", label: "Address Line 2", placeholder: "Address Line 2" }))),
            React.createElement("br", null),
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                            validate: function (value) { return areMailingFieldsValid(value) || "A city is required."; },
                        }), type: "text", field: "mailingCity", label: "City", placeholder: "City" })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                            validate: function (value) { return areMailingFieldsValid(value) || "A state/province is required."; },
                        }), type: "text", field: "mailingState", label: "State/Province", placeholder: "State/Province" }))),
            React.createElement("br", null),
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                            validate: function (value) { return areMailingFieldsValid(value) || "A country is required."; },
                        }), type: "country", field: "mailingCountry", placeholder: "Country", label: "Country" })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { useHookResponse: useHookResponse, inputRef: register({
                            required: false,
                            validate: function (value) { return areMailingFieldsValid(value) || "A zip/postal code is required."; },
                        }), type: "text", field: "mailingZip", placeholder: "Zip/Postal Code", label: "Zip/Postal Code" }))))));
};
exports.default = MailingAddress;
//# sourceMappingURL=mailing-address.js.map